<template>
  <div>
      <Login v-if="curUser.username.length === 0" @connect="connect"></Login>
      <UserSettings v-if="curUser.username.length > 0" :curUser="curUser" @connect="connect"></UserSettings>
  </div>
</template>

<script>
import Login from '@/components/Login.vue'
import UserSettings from '@/components/UserSettings.vue'
import {ref, inject} from 'vue';

export default {
  name: 'Home',
  components: {
    Login,
    UserSettings
  },
  setup() {
    const emitter = inject('emitter')
    emitter.on('disconnect', function() {
      clearUser();
    });

    let curUser = ref({username: ''});
    fetch("api/getuserinfo", {
        body: {},
        method: "post"
    }).then(function(resp) {
      resp.json().then(function(json){
        if ('username' in json) {
          connect(json);
        }
      }.bind(this));
    }.bind(this));
    const clearUser = function() {
      curUser.value.username = "";
      curUser.value.typeUtilisateur = "";
      curUser.value.compteRacine = "";
      curUser.value.contact = "";
      curUser.value.langue = "";
      curUser.value.mail = "";
      curUser.value.cLigne1 = "";
      curUser.value.cLigne2 = "";
      curUser.value.fLigne1 = "";
      curUser.value.fLigne2 = "";
      curUser.value.postalCode = "";
      curUser.value.fPostalCode = "";
      curUser.value.l = "";
      curUser.value.fL = "";
      curUser.value.st = "";
      curUser.value.fSt = "";
      curUser.value.sn = "";
      curUser.value.telephoneNumber = "";
      curUser.value.representants = "";
    }
    const connect = function(user) {
      clearUser();
      if ('username' in user) {
        emitter.emit('connect', {})
        curUser.value.username = user.username;
        curUser.value.typeUtilisateur = user.typeUtilisateur;
        curUser.value.compteRacine = user.compteRacine;
        curUser.value.contact = user.contact;
        curUser.value.langue = user.langue;
        curUser.value.mail = user.mail;
        curUser.value.cLigne1 = user.cLigne1;
        curUser.value.cLigne2 = user.cLigne2;
        curUser.value.fLigne1 = user.fLigne1;
        curUser.value.fLigne2 = user.fLigne2;
        curUser.value.postalCode = user.postalCode;
        curUser.value.fPostalCode = user.fPostalCode;
        curUser.value.l = user.l;
        curUser.value.fL = user.fL;
        curUser.value.st = user.st;
        curUser.value.fSt = user.fSt;
        curUser.value.sn = user.sn;
        curUser.value.telephoneNumber = user.telephoneNumber;
        curUser.value.representants = user.representants;
      }
    }
    return {
      connect,
      curUser
      };
  }
}


</script>
